// ASTRIXY.ONLINE — shopper (Customer OS) auth session.
// Deliberately isolated from the ASTRIXY.APP merchant session: same backend,
// separate storage key, so signing in/out on one surface never affects the other.
import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const URL = import.meta.env['VITE_SUPABASE_URL'] as string;
const KEY = import.meta.env['VITE_SUPABASE_PUBLISHABLE_KEY'] as string;

export const ONLINE_STORAGE_KEY = 'astrixy-online-auth';

let cached: SupabaseClient | null = null;

export function onlineAuthClient(): SupabaseClient {
  if (cached) return cached;
  cached = createClient(URL, KEY, {
    auth: {
      storageKey: ONLINE_STORAGE_KEY,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  });
  return cached;
}

export async function onlineAccessToken(): Promise<string | null> {
  if (typeof window === 'undefined') return null;
  const { data } = await onlineAuthClient().auth.getSession();
  return data.session?.access_token ?? null;
}
